import Model from '../../ModelBinding/Model';
import OptionCollection from './OptionCollection';
import dayjs from 'dayjs';
import MissionStatusCollection from '../MissionStatus/MissionStatusCollection';
import ProductTypeCollection from '../ProductType/ProductTypeCollection';

export default class Option extends Model {
  public code?: string;
  public name?: string;
  public description?: string;
  public enabled?: boolean;
  public group?: 'BASIC' | 'PREMIUM' | 'GOLD' | 'EXTRA';
  public offer_item_id?: string;
  public linked_item_id?: string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public mission_statuses?: MissionStatusCollection;
  public product_types?: ProductTypeCollection;

  bind() {
    this.code = this.getStringAttribute('code');
    this.name = this.getStringAttribute('name');
    this.description = this.getStringAttribute('description');
    this.enabled = this.getBooleanAttribute('enabled');
    this.group = this.getStringAttribute('group') as
      | 'BASIC'
      | 'PREMIUM'
      | 'GOLD'
      | 'EXTRA'
      | undefined;
    this.offer_item_id = this.getStringAttribute('offer_item_id');
    this.linked_item_id = this.getStringAttribute('linked_item_id');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.mission_statuses = this.getRelationCollection(
      'mission_statuses',
      MissionStatusCollection,
    ) as MissionStatusCollection;
    this.product_types = this.getRelationCollection(
      'product_types',
      ProductTypeCollection,
    ) as ProductTypeCollection;
  }

  static getCollection() {
    return OptionCollection;
  }
}
